<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">人员组件
      <el-button
        type="danger"
        style="margin-left: 8px;"
        @click="deleteitem">删除</el-button>
    </div>
    <!-- <div>目前只做占位，无配置项，自动获取排序优先级最高的前5个</div> -->
    <expert-top-list />
  </el-card>
</template>
<script>
import ExpertTopList from '../list-top-flag/expert-top-list.vue'
export default {
  name: 'WeExpert',
  components: { ExpertTopList },
  props: {
    value: {
      type: Object,
      default() {
        return { componentName: 'expertshow', visible: false }
      }
    },
    index: Number
  },
  methods: {
    deleteitem() {
      this.$emit('deleteItem', this.index)
    },
    submit() {
      return Promise.resolve()
    }
  }
}
</script>
<style lang="stylus">
.settings {
  // display: flex;
  // flex-direction: column;
}

.settings .el-card__header {
  padding: 10px 20px;
}

.settings .el-card__body {
  // flex: 1;
  padding: 10px;
  // display: flex;
  // flex-direction: column;
}

.settings .settings-header {
  font-size: 16px;
  font-weight: 600;
}
</style>
